<template>
  <div class="profile">
    <profileChangeAddressComponent @refreshFavRest="getFavRestaurant" />
    <profileChangePasswordComponent />
    <profileChangePermissionsComponent />
    <profileRemoveChildComponent
      :emailParent="emailParent"
      :selectedChild="selectedChild"
      :lastChild="lastChild"
    />
    <profileDataAddChildComponent @addedChild="fetchJson" />
    <gewinneModal/>

    <b-row class="justify-content-center">
      <b-col sm="10">
        <h1 class="text-center">Dein McDonald’s Junior Club!</h1>
        <h5 class="text-center mb-30">Hier kannst du deine Mitgliedschaft verwalten.</h5>
      </b-col>
    </b-row>
    <b-row class="justify-content-center">
      <b-col sm="8" lg="5" class="float-none">
        <h2 class="h3">Deine Daten</h2>
        <div class="section mb-15">
          <div class="row header">
            <div class="col-6">
              <p class="small">Persönliche Daten des Elternteils</p>
            </div>
            <div class="col-6 text-right">
              <a class="link small" v-b-modal.updateAddress>Ändern</a>
            </div>
          </div>
          <div class="personal-details text-black-50 mb-15" v-if="items.address">
            {{ items.firstname }} {{ items.lastname }}
            <br />
            {{ items.address.street }} {{ items.address.housenumber }}
            <br />
            {{ items.address.postcode }} {{items.address.city }}
            <br />
            {{ items.address.country | filterCountry }}
          </div>

          <div class="header">
            <p
              class="small fav-rest-label"
            >Wähle dein McDonald's Lieblingsrestaurant und löse exklusiv hier deine Gutscheine ein.</p>
          </div>
          <p class="text-black-50">{{favRestaurant}}</p>
        </div>
      </b-col>
    </b-row>
    <b-row class="justify-content-center mb-30 mt-30">
      <b-col sm="8" lg="5">
        <div class="section mb-15">
          <div class="header">
            <p class="small">E-Mail Elternteil</p>
          </div>
          <p class="text-black-50">{{ items.parentEmail }}</p>
        </div>
      </b-col>
    </b-row>

    <b-row class="justify-content-center mb-30">
      <b-col sm="8" lg="5">
        <div class="section mb-15">
          <div class="header row">
            <div class="col-6">
              <p class="small">Passwort</p>
            </div>
            <div class="col-6 text-right">
              <a class="link small" v-b-modal.updatePassword>Ändern</a>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="justify-content-center">
      <b-col sm="8" lg="5">
        <h2 class="h3">Angemeldete Kinder</h2>
        <div class="section mb-15">
          <div
            class="p-0 mb-30 child"
            v-for="(child, index) in items.children"
            :key="child.membershipNumber"
            :class="{inactive: !tooOld(child.birthYear)}"
          >
            <div class="header row">
              <div class="col-6 small">{{ index + 1 }}. Kind</div>
              <div class="col-6 text-right">
                <a class="link small" v-b-modal.removeChild @click="sendChildData(child)">
                  Kind
                  abmelden
                </a>
              </div>
            </div>
            <p v-if="tooOld(child.birthYear)" class="mb-10 text-black-50">
              {{
              child.firstname }} {{child.lastname }}
<!--              ({{ child.salutation | filterSalutation }})-->
              <br />
              {{ child.birthMonth | filterMonth }} {{ child.birthYear }}
              <br />
              {{ child.membershipNumber }}
            </p>
            <p v-else class="mb-10 text-black-50">
              XXXX XXXXXXXXX
<!--              ({{ child.salutation | filterSalutation }})-->
              <br />
              <span class="red">{{ child.birthMonth | filterMonth }} {{ child.birthYear }}</span>
              <span class="small">(Altersgrenze überschritten)</span>
              <br />
              {{ child.membershipNumber }}
            </p>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="justify-content-center" v-if="inactiveAccount()">
      <b-col sm="8" lg="5">
        <div class="alert alert-primary">
          <strong>Hinweis:</strong> Solange kein weiteres Kind unter 14 Jahren angemeldet wird ist die
          Mitgliedschaft beim McDonald's Junior Club inaktiv.
          <br />Hol dir unsere App - hier warten tolle
          Angebote und News auf dich.
          <div class="row mt-15">
            <div class="col-6">
              <a href="https://itunes.apple.com/de/app/mcdonalds-deutschland/id524943492?mt=8">
                <img src="assets/images/app-store.svg" alt />
              </a>
            </div>
            <div class="col-6">
              <a href="https://play.google.com/store/apps/details?id=de.mcdonalds.mcdonaldsinfoapp">
                <img src="assets/images/google-play.svg" alt />
              </a>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="justify-content-center mb-30" v-if="items.children && items.children.length < 5">
      <b-col sm="8" lg="5">
        <a class="btn btn-primary bg-gradient-primary" v-b-modal.addNewChild>+ Neues Kind anmelden</a>
      </b-col>
    </b-row>

    <b-row class="justify-content-center mt-30 mb-30">
      <b-col sm="8" lg="5">

        <!--  ###################################
          GWS CTA / Eyecatcher for PopUp
        #########################################
        -->
<!--        <a v-b-modal.gewinneModal class="text-center eyecatcher">-->
<!--          <img src="/assets/images/Stoerer-350x350.png" width="175" height="175" class="mb-30 mr-60">-->
<!--        </a>-->


        <h3>Newsletter Anmeldung</h3>
<!--        <p v-if="items.optin2.optinAgreement"-->
<!--        >Du möchtest die Family News nicht mehr erhalten? Schade, aber dann kannst du dich hier abmelden.</p>-->
<!--        <p v-else>-->
<!--          Erhaltet immer als Erste alle News rund um Family-Themen bei McDonald’s sowie viele spannende-->
<!--          Familienthemen direkt in euer Postfach.-->
<!--          &lt;!&ndash;  ###################################-->
<!--          GWS + Teilnahmebedingungen & Datenschutz-->
<!--          #########################################-->
<!--          &ndash;&gt;-->
<!--&lt;!&ndash;          Hier findest du die&ndash;&gt;-->
<!--&lt;!&ndash;          <a href="https://www.mcdonalds.com/content/dam/de/Datenschutz/Datenschutzinformationen-Chilis-16.11.20.pdf" title="Datenschutzinformationen" target="_blank">Datenschutzinformationen</a>.&ndash;&gt;-->
<!--        </p>-->
        <p>
          Du willst immer up to date sein? Aktuelle News zu neuen Produkten erhalten?
          Oder keine exklusiven Coupons und Gewinnspiele verpassen? Dann hol dir jetzt
          die McDonald’s App - wenn du sie nicht schon hast - registriere dich in der
          App und melde dich für den McDonald’s Newsletter an!
        </p>
        <a href="https://www.mcdonalds.com/de/de-de/ueber-uns/newsletter.html" class="btn btn-primary">So geht's</a>
<!--        <a-->
<!--          v-if="items.optin2.optinAgreement"-->
<!--          v-b-modal.updatePermissions-->
<!--          class="btn btn-primary"-->
<!--        >Abmelden</a>-->
<!--        <a v-else v-b-modal.updatePermissions class="btn btn-primary">Abonnieren</a>-->
      </b-col>
    </b-row>

    <b-row class="justify-content-center mt-50 mb-30">
      <b-col sm="8" lg="5">
        <h3>Meine Einwilligungen</h3>
        <p>
          Du hast folgende Einwilligungen gegeben. Diese sind für die Mitgliedschaft im McDonald’s Junior Club
          nötig.
        </p>
        <div class="form-group">
          <p class="mandatory-note">Einwilligung zur Datenverarbeitung:</p>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="optin-1"
              checked
              disabled
              v-b-modal.updatePermissions
            />
            <label class="form-check-label text-black-50" for="optin-1">
              Ich stimme in meinem Namen und im Namen meines Kindes (meiner Kinder) zu, dass die
              McDonald's Deutschland LLC, Zweigniederlassung München die oben angegebenen Daten
              verarbeitet, um mir für mein Kind (meine Kinder) (im Alter zwischen 0 und 13 Jahren) einen
              Geburtstagsgutschein elektronisch und per Post zuzusenden. Diese Zustimmung kann ich auch
              nachträglich jederzeit gegenüber der McDonald's Deutschland LLC, Zweigniederlassung München
              per E-Mail an datenschutz@de.mcd.com widerrufen. Der Widerruf lässt die Rechtmäßigkeit der
              Verarbeitung bis zum Widerruf unberührt.
            </label>
          </div>
          <p class="mandatory-note">Einwilligung zu Teilnahmebedingungen und Datenschutz *:</p>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="optin-3"
              checked
              disabled
              v-b-modal.updatePermissions
            />
            <label class="form-check-label text-black-50" for="optin-3">
              Ich stimme den Teilnahmebedingungen zu und habe die McDonald’s <a href="https://www.mcdonalds.com/content/dam/sites/de/unreferenced/Datenschutz/Datenschutzinformationen_McDonalds_Junior_Club.pdf" target="_blank">Datenschutzerklärung</a> zur
              Kenntnis genommen
            </label>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="justify-content-center">
      <b-col sm="8" lg="5">
        <h3>Du hast Fragen?</h3>
        <p>Kontaktiere uns gern jederzeit.</p>
        <p>
          McDonald's Club Center
          <br />Postfach 5050
          <br />33413 Verl
          <br />
          <a href="mailto:info@mcdonalds-junior-club.de">info@mcdonalds-junior-club.de</a>
        </p>
      </b-col>
    </b-row>
  </div>
</template>
<style lang="scss">
</style>
<script>
import profileChangeAddressComponent from "../components/profile-change-address.vue";
import profileDataAddChildComponent from "../components/profile-add-child.vue";
import profileChangePasswordComponent from "../components/profile-change-password.vue";
import profileChangePermissionsComponent from "../components/profile-change-permissions";
import profileRemoveChildComponent from "../components/profile-remove-child";
import { apiRemoveChild, apiLoginParent } from "../utils/api";
import gewinneModal from "../components/gewinne-modal.vue";

export default {
  name: "profileView",
  components: {
    profileChangeAddressComponent,
    profileDataAddChildComponent,
    profileChangePasswordComponent,
    profileChangePermissionsComponent,
    profileRemoveChildComponent,
    gewinneModal
  },
  props: {
    msg: String
  },
  data() {
    return {
      removeChildResponse: [],
      email: "",
      password: "",
      selectedChild: "",
      emailParent: "",
      favRestaurant: "",
      lastChild: false
    };
  },
  methods: {
    getFavRestaurant() {
      //https://www.mcdonalds.de/search/widget/jc/restaurants
      this.axios
        .get("https://mcduploaderst2.blob.core.windows.net/restaurants/juniorclub-restaurants.json")
        .then(response => {
          let rests = response.data,
            id = this.items.favoriteRestaurant;

          const favRest = rests.filter(rest => rest["0"] == id);

          this.favRestaurant =
            favRest[0]["3"] + ", " + favRest[0]["1"] + " " + favRest[0]["2"];
        })
        .catch(e => {
          this.$store.commit("error", e);
        });
    },

    removeChild(email, membershipNumber) {
      this.$store.commit("updateProfileRemoveChild", membershipNumber);

      apiRemoveChild({
        email: email,
        membershipNumber: membershipNumber
      })
        .then(response => {
          this.removeChildResponse = response.data;
        })
        .catch(e => {
          this.$store.commit("error", e);
        });
    },

    sendChildData(item) {
      this.selectedChild = item;

      if (this.items.children.length < 2) this.lastChild = true;
    },
    inactiveAccount() {
      let tooOld = [];

      this.items.children.map(child => {
        if (child.birthYear < new Date().getFullYear() - 14) tooOld.push("1");
      });

      if (tooOld.length > 0)
        return (
          this.items.children && this.items.children.length < tooOld.length + 1
        );
      else return this.items.children && this.items.children.length < 1;
    },

    tooOld(birthYear) {
      return birthYear > new Date().getFullYear() - 14;
    },

    fetchJson() {
      apiLoginParent({
        email: this.$store.state.user.email,
        passwordhash: this.$store.state.user.password
      })
        .then(response => {
          // JSON responses are automatically parsed.
          this.$store.commit("storeProfileData", response.data);
        })
        .then(() => {
          this.getFavRestaurant();
        })
        .catch(e => {
          this.$store.commit("error", e);
        });
    }
  },
  computed: {
    items() {
      // todo: Remove side effect from computed
      // eslint-disable-next-line
      this.emailParent = this.$store.state.profileData.parentEmail;
      return this.$store.state.profileData;
    }
  },
  created() {
    this.fetchJson("");
  }
};
</script>
